import React from 'react'
import styled from 'styled-components'

import CMS from '@talus-analytics/library.airtable-cms'
import useIndexPageData from '../../../../cmsHooks/useIndexPageData'

import { SectionHeader } from '../../../ui'
import { Center, FullWidthSection, ContentContainer } from '../../../layout'
import ProcessStep from '../ProcessStep'
import device from '../../../../utilities/device'

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 30px;
  margin-top: 50px;
  @media ${device.laptop} {
    grid-template-columns: 1fr;
    > div {
      &:not(:last-child) {
        margin-bottom: 60px;
      }
    }
    p {
      font-size: 20px;
      line-height: 1.4em;
    }
  }
  @media ${device.mobileL} {
    p {
      font-size: 18px;
    }
  }
`
const ProcessSection = (): JSX.Element => {
  const data = useIndexPageData()

  return (
    <FullWidthSection dark>
      <ContentContainer>
        <Center>
          <SectionHeader light center>
            <CMS.Text name="Process headline" data={data} />
          </SectionHeader>
          <Grid>
            <ProcessStep step={1} />
            <ProcessStep step={2} />
            <ProcessStep step={3} />
          </Grid>
        </Center>
      </ContentContainer>
    </FullWidthSection>
  )
}

export default ProcessSection
